import { render, staticRenderFns } from "./TouchToStart.vue?vue&type=template&id=9033a99a&"
import script from "./TouchToStart.vue?vue&type=script&lang=js&"
export * from "./TouchToStart.vue?vue&type=script&lang=js&"
import style0 from "./TouchToStart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports